import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { MdClose } from "react-icons/md";
import { HiMenuAlt2 } from "react-icons/hi";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa"; 
import { motion } from "framer-motion";
import { logo, logoLight } from "../../../assets/images";
import Image from "../../designLayouts/Image";
import { navBarList } from "../../../constants"; 
import Flex from "../../designLayouts/Flex";

const Header = () => {
  const [showMenu] = useState(true);
  const [sidenav, setSidenav] = useState(false);
  const [category, setCategory] = useState(false);
  const [brand, setBrand] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="w-full h-20 bg-white sticky top-0 z-50 border-b border-gray-200">
      <nav className="h-full px-4 max-w-container mx-auto relative">
        <Flex className="flex items-center justify-between h-full">
          
          <Link to="/">
            <div>
              <Image className="w-40 object-cover" imgSrc={logo} />
            </div>
          </Link>

          
          <div className="hidden md:flex flex-grow justify-center">
            {showMenu && (
              <motion.ul
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="flex items-center w-auto z-50 p-0 gap-2"
              >
                {navBarList.map(({ _id, title, link, dropdown }) => {
                  if (!title || typeof title !== 'string') {
                    console.warn(`Invalid title for navBarList item with id ${_id}:`, title);
                    return null; 
                  }

                  return dropdown && dropdown.length > 0 ? (
                    <div key={_id} className="relative group">
                      <button className="flex font-normal hover:font-bold justify-center items-center px-4 py-2 text-base text-[#767676] hover:underline underline-offset-[4px] decoration-[1px] hover:text-[#262626] md:border-r-2 border-r-gray-300 hoverEffect last:border-r-0">
                        {title}
                      </button>
                      <div className="absolute hidden group-hover:block bg-white shadow-lg">
                        {dropdown.map(item => {
                          if (!item.title || typeof item.title !== 'string') {
                            console.warn(`Invalid dropdown title for navBarList item with id ${item._id}:`, item.title);
                            return null; 
                          }
                          return (
                            <NavLink
                              key={item._id}
                              to={item.link}
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            >
                              {item.title}
                            </NavLink>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <NavLink
                      key={_id}
                      to={link}
                      className="flex font-normal hover:font-bold justify-center items-center px-4 py-2 text-base text-[#767676] hover:underline underline-offset-[4px] decoration-[1px] hover:text-[#262626] md:border-r-2 border-r-gray-300 hoverEffect last:border-r-0"
                    >
                      <li>{title}</li>
                    </NavLink>
                  );
                })}
              </motion.ul>
            )}
          </div>

          
          <div className="flex items-center space-x-4 md:space-x-6">
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600">
              <FaFacebookF className="w-6 h-6" />
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-pink-600">
              <FaInstagram className="w-6 h-6" />
            </a>
            <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-400">
              <FaTwitter className="w-6 h-6" />
            </a>
            <HiMenuAlt2
              onClick={() => setSidenav(!sidenav)}
              className="md:hidden inline-block cursor-pointer w-8 h-6"
            />
          </div>

          
          {sidenav && (
            <div className="fixed top-0 left-0 w-full h-screen bg-black text-gray-200 bg-opacity-80 z-50">
              <motion.div
                initial={{ x: -300, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="w-[80%] h-full relative"
              >
                <div className="w-full h-full bg-primeColor p-6">
                  <img className="w-28 mb-6" src={logoLight} alt="logoLight" />
                  <ul className="text-gray-200 flex flex-col gap-2">
                    {navBarList.map(item => {
                      if (!item.title || typeof item.title !== 'string') {
                        console.warn(`Invalid title for navBarList item with id ${item._id}:`, item.title);
                        return null; 
                      }

                      return (
                        <li key={item._id} className="font-normal hover:font-bold items-center text-lg text-gray-200 hover:underline underline-offset-[4px] decoration-[1px] hover:text-white">
                          <NavLink
                            to={item.link}
                            state={{ data: location.pathname.split("/")[1] }}
                            onClick={() => setSidenav(false)}
                          >
                            {item.title}
                          </NavLink>
                        </li>
                      );
                    })}
                  </ul>
                  <div className="mt-4">
  <h1 onClick={() => setCategory(!category)} className="flex justify-between text-base cursor-pointer items-center font-titleFont mb-2">
    Shop by Category{" "}
    <span className="text-lg">{category ? "-" : "+"}</span>
  </h1>
  {category && (
    <motion.ul
      initial={{ y: 15, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="text-sm flex flex-col gap-1"
    >
      <NavLink to="/shop" className="headerSedenavLi">New Arrivals</NavLink>
      <NavLink to="/shop" className="headerSedenavLi">Special Offer</NavLink>
      <NavLink to="/shop" className="headerSedenavLi">Best Seller</NavLink>
      <NavLink to="/shop" className="headerSedenavLi">New Products</NavLink>
      <NavLink to="/shop" className="headerSedenavLi">Others</NavLink>
    </motion.ul>
  )}
</div>
<div className="mt-4">
  <h1 onClick={() => setBrand(!brand)} className="flex justify-between text-base cursor-pointer items-center font-titleFont mb-2">
    Shop by Brand
    <span className="text-lg">{brand ? "-" : "+"}</span>
  </h1>
  {brand && (
    <motion.ul
      initial={{ y: 15, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="text-sm flex flex-col gap-1"
    >
      <NavLink to="/shop" className="headerSedenavLi">GFC</NavLink>
      <NavLink to="/shop" className="headerSedenavLi">Dawlance</NavLink>
      <NavLink to="/shop" className="headerSedenavLi">Haier</NavLink>
      <NavLink to="/shop" className="headerSedenavLi">Pel</NavLink>
      <NavLink to="/shop" className="headerSedenavLi">Others</NavLink>
    </motion.ul>
  )}
</div>

                </div>
                <span
                  onClick={() => setSidenav(false)}
                  className="w-8 h-8 border border-gray-300 absolute top-2 -right-10 text-gray-300 text-2xl flex justify-center items-center cursor-pointer hover:border-red-500 hover:text-red-500 duration-300"
                >
                  <MdClose />
                </span>
              </motion.div>
            </div>
          )}
        </Flex>
      </nav>
    </div>
  );
};

export default Header;
